import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Feature {
    iconUrl:string;
    title: string;
    description: string;
}

interface ResultStat {
    label: string;
    value: string;
}

@Component({
    selector: 'app-features-and-results-section',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './features-and-results-section.component.html',
    styleUrls: ['./features-and-results-section.component.scss']
})
export class FeaturesAndResultsSectionComponent {


    features: Feature[] = [
        {
            iconUrl: 'https://imgix.cosmicjs.com/abe4c3f0-5a82-11f0-ae5a-0f56aa053fcd-computer-1.svg',
            title: 'Advanced technology',
            description: 'Dimers Platinum uses AI-powered reinforcement learning that evolves with each game of training data to deliver more profitable betting picks.',
        },
        {
            iconUrl: 'https://imgix.cosmicjs.com/abe698b0-5a82-11f0-ae5a-0f56aa053fcd-trophy-1.svg',
            title: 'Built to beat the books',
            description: 'Our model is trained directly on outcomes—profit and loss—not just statistical accuracy. It’s engineered to prioritize ROI over everything else.',
        },
        {
            iconUrl: 'https://imgix.cosmicjs.com/abe56030-5a82-11f0-ae5a-0f56aa053fcd-focus-1.svg',
            title: 'Specialized focus',
            description: 'We target one proven edge—such as college football 1Q spreads—where our data shows the highest long-term value across thousands of simulations.',
        },
        {
            iconUrl: 'https://imgix.cosmicjs.com/abe62380-5a82-11f0-ae5a-0f56aa053fcd-alarm-clock-check-1.svg',
            title: 'Weekly pick drops',
            description: 'New AI picks drop every week—simple, fast and clean. No noise—just ready-to-bet insights from one of the sharpest tools in AI sports betting.',
        },
    ];

    realResults: ResultStat[] = [
        { label: 'Satisfaction', value: '100%' },
        { label: 'Complaints', value: '0' },
        { label: 'Return rate', value: '88%' },
    ];

    constructor() { }
}